import loadable from '@loadable/component';

export const BibWidget = loadable(() => import('app/components/widgets/BibWidget/BibWidgetContainer'));
export const BrowseBibs = loadable(() => import('app/sdk/components/BrowseBibs'));
export const FeedbackBox = loadable(() => import('app/components/layouts/FeedbackBox/FeedbackBoxContainer'));
export const PreviewBar = loadable(() => import('app/components/shared/PreviewBar/PreviewBar'));
export const StaffTakeoverMessage = loadable(() => import('app/components/shared/StaffTakeoverMessage'));
export const SystemMessages = loadable(() => import('app/components/shared/SystemMessages'));
